import React from 'react';
import PropTypes from 'prop-types';
import { Header, Form } from 'semantic-ui-react';
import PaymentInformationHeader from './PaymentInformationHeader';
import PaymentSources from './PaymentSources';

const PaymentConfirm = ({ policies, sources, hidePaymentOption, actions }) => {
	return (
		<div>
			<PaymentInformationHeader policies={policies} sources={sources} hidePaymentOption={hidePaymentOption} />
			<Header>Payment Breakdown</Header>
			<PaymentSources sources={sources} actions={actions} policies={policies} />
			{sources[0].emailAddress && (
				<Form>
					<Form.Field>
						<label>Email Address</label>
						<div>{sources[0].emailAddress}</div>
					</Form.Field>
				</Form>
			)}
		</div>
	);
};

PaymentConfirm.propTypes = {
	policies: PropTypes.array.isRequired,
	sources: PropTypes.array.isRequired
};

export default PaymentConfirm;
